import { call, fork, put, takeEvery } from 'redux-saga/effects';
import { omit } from 'lodash';
import AppApi from '../../../lib/api/app/AppApi';
import OrderApi from '../../../lib/api/order/OrderApi';
import {
  _setResponseListForm,
  addAllItemToSelectList,
  asyncSimpleModal,
  excelDownLoad,
  reDirectPage,
  setMultipartForm,
  setRequestForm,
  setResponseListForm,
} from '../../../lib/common';
import toastMsg from '../../../lib/toastMsg';
import noticeExcelDownloadResult from '../../../lib/noticeExcelDownloadResult';
import orderActions from './actions';
import orderToastMsg from '../../../constants/service/toastMsg/orderToastMsg';
import { ORDER_RETURN_LIST_URL_PATH } from '../../../constants/service/common/urlConstants';
import { initOrderDetailListOption } from '../../../containers/order/OrderDetailContainer';
import { ORDER_RES_CODE } from '../../../constants/responseCode/orderResCode';

function* fetchList() {
  /**
   *  [주문 전체 리스트] 주문 전체 리스트 요청하기
   */
  yield takeEvery(orderActions.GET_ORDER_ALL_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.getOrderAllList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(orderToastMsg.GET_ORDER_ALL_LIST_REQUEST_SUCCESS);

        const data = {
          orderAllList: setResponseListForm(result.data.orderAllList, result.data.totalCnt, payload),
          orderSummaryBox: result.data.orderSummaryBox,
        };

        yield put({ type: orderActions.GET_ORDER_ALL_LIST_SUCCESS, payload: data });

        /**
         *  상품 1차 카테고리
         */
        yield put(
          orderActions.setData({
            path: ['mainProductCategorySelectList'],
            value: result.data.mainProductCategorySelectList,
          }),
        );
      }
    } catch (error) {
      toastMsg.error(orderToastMsg.GET_ORDER_ALL_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *  [주문 전체 리스트] 주문 전체 리스트 엑셀 다운로드 요청하기
   */
  yield takeEvery(orderActions.GET_ORDER_ALL_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.getOrderAllListExcelDownload, setRequestForm(payload, true));
      noticeExcelDownloadResult(payload.email, result.msg);
    } catch (error) {
      toastMsg.error(error.message || orderToastMsg.GET_ORDER_ALL_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR);
    }
  });

  /**
   *  [주문 취소 리스트] 주문 취소 리스트 요청하기
   */
  yield takeEvery(orderActions.GET_ORDER_CANCEL_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.getOrderCancelList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(orderToastMsg.GET_ORDER_CANCEL_LIST_REQUEST_SUCCESS);

        const data = {
          orderCancelList: setResponseListForm(result.data.orderCancelList, result.data.totalCnt, payload),
          orderCancelSummaryBox: result.data.orderCancelSummaryBox,
        };
        yield put({ type: orderActions.GET_ORDER_CANCEL_LIST_SUCCESS, payload: data });

        /**
         *  상품 1차 카테고리
         */
        yield put(
          orderActions.setData({
            path: ['mainProductCategorySelectList'],
            value: result.data.mainProductCategorySelectList,
          }),
        );
      }
    } catch (error) {
      toastMsg.error(orderToastMsg.GET_ORDER_CANCEL_LIST_REQUEST_ERROR);
    }
  });

  /**
   *  [주문 취소 리스트] 주문 취소 리스트 엑셀 다운로드 요청하기
   */
  yield takeEvery(orderActions.GET_ORDER_CANCEL_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.getOrderCancelListExcelDownload, setRequestForm(payload, true));
      noticeExcelDownloadResult(payload.email, result.msg);
    } catch (error) {
      toastMsg.error(error.message || orderToastMsg.GET_ORDER_CANCEL_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR);
    }
  });

  /**
   *  [주문 반품 리스트] 주문 반품 리스트 요청하기
   */
  yield takeEvery(orderActions.GET_ORDER_RETURN_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.getOrderReturnList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(orderToastMsg.GET_ORDER_RETURN_DETAIL_REQUEST_SUCCESS);

        const data = {
          orderReturnList: setResponseListForm(result.data.orderReturnList, result.data.totalCnt, payload),
          orderReturnSummaryBox: result.data.orderReturnSummaryBox,
        };
        yield put({ type: orderActions.GET_ORDER_RETURN_LIST_SUCCESS, payload: data });

        /**
         *  상품 1차 카테고리
         */
        yield put(
          orderActions.setData({
            path: ['mainProductCategorySelectList'],
            value: result.data.mainProductCategorySelectList,
          }),
        );
      }
    } catch (error) {
      toastMsg.error(orderToastMsg.GET_ORDER_RETURN_DETAIL_REQUEST_ERROR);
    }
  });

  /**
   *  [주문 반품 리스트] 주문 반품 리스트 엑셀 다운로드 요청하기
   */
  yield takeEvery(orderActions.GET_ORDER_RETURN_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.getOrderReturnListExcelDownload, setRequestForm(payload, true));
      noticeExcelDownloadResult(payload.email, result.msg);
    } catch (error) {
      toastMsg.error(error.message || orderToastMsg.GET_ORDER_RETURN_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR);
    }
  });

  /**
   *  [주문 교환 리스트] 주문 교환 리스트 요청하기
   */
  yield takeEvery(orderActions.GET_ORDER_EXCHANGE_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.getOrderExchangeList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(orderToastMsg.GET_ORDER_EXCHANGE_LIST_REQUEST_SUCCESS);

        const data = {
          orderExchangeList: setResponseListForm(result.data.orderExchangeList, result.data.totalCnt, payload),
          orderExchangeSummaryBox: result.data.orderExchangeSummaryBox,
        };
        yield put({ type: orderActions.GET_ORDER_EXCHANGE_LIST_SUCCESS, payload: data });

        /**
         *  상품 1차 카테고리
         */
        yield put(
          orderActions.setData({
            path: ['mainProductCategorySelectList'],
            value: result.data.mainProductCategorySelectList,
          }),
        );
      }
    } catch (error) {
      toastMsg.error(orderToastMsg.GET_ORDER_EXCHANGE_LIST_REQUEST_ERROR);
    }
  });

  /**
   *  [주문 교환 리스트] 주문 교환 리스트 엑셀 다운로드 요청하기
   */
  yield takeEvery(orderActions.GET_ORDER_EXCHANGE_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.getOrderExchangeListExcelDownload, setRequestForm(payload, true));
      noticeExcelDownloadResult(payload.email, result.msg);
    } catch (error) {
      toastMsg.error(error.message || orderToastMsg.GET_ORDER_EXCHANGE_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR);
    }
  });

  /**
   *  [주문/배송관리] 주문/배송관리 리스트 요청하기
   */
  yield takeEvery(orderActions.GET_ORDER_MANAGEMENT_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(
        OrderApi.getOrderManagementList,
        setRequestForm(
          {
            ...payload,
            filterOption: {
              ...payload.filterOption,
              modifiedDeliveryInfo:
                payload.filterOption.modifiedDeliveryInfo.length > 1 ? [] : payload.filterOption.modifiedDeliveryInfo,
            },
          },
          true,
        ),
      );
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.GET_ORDER_MANAGEMENT_LIST_REQUEST_SUCCESS);

      const data = {
        ..._setResponseListForm(result.data.orderItemList, result.data.totalCnt, payload),
        deliveryAgentList: result.data.deliveryAgentList,
      };

      yield put({ type: orderActions.GET_ORDER_MANAGEMENT_LIST_SUCCESS, payload: data });
    } catch (error) {
      toastMsg.error(orderToastMsg.GET_ORDER_MANAGEMENT_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *  [주문/배송관리] 상품 주문 상품 준비 처리하기
   */
  yield takeEvery(orderActions.DELIVERY_PREPARATION_ORDER_MANAGEMENT_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.deliveryPreparation, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.DELIVERY_PREPARATION_ORDER_MANAGEMENT_REQUEST_SUCCESS);

      const data = {
        orderItemIdList: result.data.orderItemIdList,
        deliveryPrepareDate: result.data.deliveryPrepareDate,
      };

      yield put({ type: orderActions.DELIVERY_PREPARATION_ORDER_MANAGEMENT_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(orderToastMsg.DELIVERY_PREPARATION_ORDER_MANAGEMENT_REQUEST_ERROR, e);
    }
  });

  /**
   *  [주문/배송관리] 상품 주문 배송 지연처리하기
   */
  yield takeEvery(orderActions.DELIVERY_DELAY_ORDER_MANAGEMENT_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.deliveryDelay, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.DELIVERY_PREPARATION_ORDER_MANAGEMENT_REQUEST_SUCCESS);

      const data = {
        orderItemIdList: result.data.orderItemIdList,
      };

      yield put({ type: orderActions.DELIVERY_DELAY_ORDER_MANAGEMENT_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(orderToastMsg.DELIVERY_PREPARATION_ORDER_MANAGEMENT_REQUEST_ERROR, e);
    }
  });

  /**
   *  [주문/배송관리] 상품 주문 발송 처리전 유효성 체크하기
   */
  yield takeEvery(orderActions.CHECK_DELIVERY_DISPATCH_ORDER_MANAGEMENT_REQUEST, function* ({ payload }) {
    try {
      const { deliveryInfoOrderItemList } = payload;
      let orderItemIdList = deliveryInfoOrderItemList.map((item) => item.orderItemId);
      const result = yield call(OrderApi.checkDeliveryDispatch, setRequestForm({ orderItemIdList }, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      const { deliveryInfoSummary, orderItemInfoList } = result.data;
      orderItemIdList = orderItemInfoList.map((item) => item.orderItemId);

      /**
       *  발송 처리 유효성 체크 결과 모달 띄움
       */
      yield put(
        orderActions.toggleModal({
          name: 'checkDeliveryDispatchResultModal',
          data: {
            deliveryInfoSummary,
            deliveryInfoOrderItemList: deliveryInfoOrderItemList.filter((item) =>
              orderItemIdList.includes(item.orderItemId),
            ),
            orderItemInfoList,
          },
        }),
      );
    } catch (e) {
      toastMsg.error(orderToastMsg.CHECK_DELIVERY_DISPATCH_ORDER_MANAGEMENT_REQUEST_ERROR, e);
    }
  });

  /**
   *  [주문/배송관리] 상품 주문 엑셀 일괄 발송 처리전 유효성 체크하기
   */
  yield takeEvery(orderActions.CHECK_EXCEL_BULK_DELIVERY_DISPATCH_ORDER_MANAGEMENT_REQUEST, function* ({ payload }) {
    try {
      const { attachment } = payload;
      const result = yield call(OrderApi.checkExcelBulkDeliveryDispatch, setMultipartForm({ attachment }, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.CHECK_EXCEL_BULK_DELIVERY_DISPATCH_ORDER_MANAGEMENT_REQUEST_SUCCESS);

      const {
        excelBulkDeliveryInfoSummary,
        excelBulkDeliveryInfoOrderItemList,
        deliveryInfoSummary,
        orderItemInfoList,
      } = result.data;

      /**
       *  1건이라도 유효하지 않으면 발송 처리를 못하게한다.
       */
      if (excelBulkDeliveryInfoSummary.invalidCnt) {
        /**
         *  엑셀 일괄 발송 처리 유효성 체크 결과 모달 띄움
         */
        yield put(
          orderActions.toggleModal({
            name: 'checkExcelBulkDeliveryDispatchResultModal',
            data: {
              excelBulkDeliveryInfoSummary,
              excelBulkDeliveryInfoOrderItemList,
            },
          }),
        );
      } else {
        /**
         *  발송 처리 유효성 체크 결과 모달 띄움
         */
        yield put(
          orderActions.toggleModal({
            name: 'checkDeliveryDispatchResultModal',
            data: {
              deliveryInfoSummary,
              deliveryInfoOrderItemList: excelBulkDeliveryInfoOrderItemList,
              orderItemInfoList,
            },
          }),
        );
      }
    } catch (e) {
      toastMsg.error(orderToastMsg.CHECK_EXCEL_BULK_DELIVERY_DISPATCH_ORDER_MANAGEMENT_REQUEST_ERROR, e);
    }
  });

  /**
   *  [주문/배송관리] 상품 주문 발송 처리하기
   */
  yield takeEvery(orderActions.DELIVERY_DISPATCH_ORDER_MANAGEMENT_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.deliveryDispatch, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.DELIVERY_DISPATCH_ORDER_MANAGEMENT_REQUEST_SUCCESS);

      const data = {
        orderItemList: result.data.responseOrderItemList,
      };

      yield put({ type: orderActions.DELIVERY_DISPATCH_ORDER_MANAGEMENT_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(orderToastMsg.DELIVERY_DISPATCH_ORDER_MANAGEMENT_REQUEST_ERROR, e);
    }
  });

  /**
   *  [주문/배송관리] 판매 취소 전 재고, 상품상태 설정 리스트 가져오기
   */
  yield takeEvery(orderActions.GET_CANCEL_ORDER_MANAGEMENT_INFO_LIST_REQUEST, function* ({ payload }) {
    try {
      const { orderItemIdList, reasonType, reason } = payload;
      const result = yield call(OrderApi.getCancelOrderManagementInfoList, setRequestForm({ orderItemIdList }, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.GET_CANCEL_ORDER_MANAGEMENT_INFO_LIST_REQUEST_SUCCESS);

      yield put(
        orderActions.toggleModal({
          name: 'cancelSalesConfirmModal',
          data: {
            reasonType,
            reason,
            orderItemList: result.data.orderItemList,
          },
        }),
      );
    } catch (e) {
      toastMsg.error(orderToastMsg.GET_CANCEL_ORDER_MANAGEMENT_INFO_LIST_REQUEST_ERROR, e);
    }
  });

  /**
   *  [주문/배송관리] 판매 취소하기
   */
  yield takeEvery(orderActions.CANCEL_SALES_ORDER_MANAGEMENT_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.cancelSales, setRequestForm(payload, true));
      if (result.status === ORDER_RES_CODE.CAN_NOT_CANCEL_PART_ORDER_ITEM) {
        toastMsg.error(orderToastMsg.CAN_NOT_CANCEL_PART_ORDER_ITEM);
        return;
      }

      if (result.msg) {
        yield asyncSimpleModal({
          type: 'error',
          title: '판매 취소',
          message: result.msg,
        });
        return;
      }

      toastMsg.success(orderToastMsg.CANCEL_SALES_ORDER_MANAGEMENT_REQUEST_SUCCESS);

      const data = {
        orderItemIdList: payload.orderItemList.map((item) => item.orderItemId),
      };

      yield put({ type: orderActions.CANCEL_SALES_ORDER_MANAGEMENT_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(orderToastMsg.CANCEL_SALES_ORDER_MANAGEMENT_REQUEST_ERROR, e);
    }
  });

  /**
   *  [주문/배송관리] 주문자 정보 수정하기
   */
  yield takeEvery(orderActions.EDIT_BUYER_INFO_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.editBuyerInfo, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.EDIT_BUYER_INFO_REQUEST_SUCCESS);

      const data = {
        orderItemModifyId: result.data.orderItemModifyId,
        giftStatusUpdateOrderId: result.data.giftStatusUpdateOrderId,
        targetOrderItem: payload,
      };

      yield put({ type: orderActions.EDIT_BUYER_INFO_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(orderToastMsg.EDIT_BUYER_INFO_REQUEST_ERROR, e);
    }
  });

  /**
   *  [주문/배송관리] 송장 수정하기
   */
  yield takeEvery(orderActions.EDIT_DELIVERY_INFO_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.editDeliveryInfo, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.EDIT_DELIVERY_INFO_REQUEST_SUCCESS);

      const data = {
        orderItemStatusList: result.data.orderItemStatusList,
        orderItemList: result.data.responseOrderItemList,
      };

      yield put({ type: orderActions.DELIVERY_DISPATCH_ORDER_MANAGEMENT_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(orderToastMsg.EDIT_DELIVERY_INFO_REQUEST_ERROR, e);
    }
  });

  /**
   *  [주문/배송관리] 전체 엑셀 다운로드
   *  브랜드별 파일 분할 다운로드 가능
   */
  yield takeEvery(orderActions.GET_ALL_ORDER_MANAGEMENT_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const { split, ...restPayload } = payload;

      const result = yield call(
        split ? OrderApi.getAllManagementListExcelSplitDownLoad : OrderApi.getAllManagementListExcelDownLoad,
        setRequestForm(
          {
            ...restPayload,
            filterOption: {
              ...restPayload.filterOption,
              modifiedDeliveryInfo:
                restPayload.filterOption.modifiedDeliveryInfo.length > 1
                  ? []
                  : restPayload.filterOption.modifiedDeliveryInfo,
            },
          },
          true,
        ),
      );
      noticeExcelDownloadResult(restPayload.email, result.msg);
    } catch (e) {
      toastMsg.error(e.message || orderToastMsg.GET_ALL_ORDER_MANAGEMENT_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR);
    }
  });

  /**
   *  [주문/배송관리] 선택 엑셀 다운로드
   *  브랜드별 파일 분할 다운로드 가능
   */
  yield takeEvery(orderActions.GET_SELECTED_ORDER_MANAGEMENT_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const { split, ...restPayload } = payload;

      const result = yield call(
        split ? OrderApi.getSelectedManagementListExcelSplitDownLoad : OrderApi.getSelectedManagementListExcelDownLoad,
        setRequestForm(
          {
            ...restPayload,
            filterOption: {
              ...restPayload.filterOption,
              modifiedDeliveryInfo:
                restPayload.filterOption.modifiedDeliveryInfo.length > 1
                  ? []
                  : restPayload.filterOption.modifiedDeliveryInfo,
            },
          },
          true,
        ),
      );
      noticeExcelDownloadResult(restPayload.email, result.msg);
    } catch (e) {
      toastMsg.error(e.message || orderToastMsg.GET_SELECTED_ORDER_MANAGEMENT_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR);
    }
  });

  /**
   *  [취소 관리] 취소 관리 리스트 요청하기
   */
  yield takeEvery(orderActions.GET_ORDER_CANCEL_MANAGEMENT_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.getOrderCancelManagementList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.GET_ORDER_CANCEL_MANAGEMENT_LIST_REQUEST_SUCCESS);

      const data = {
        orderCancelManagementList: _setResponseListForm(result.data.orderItemList, result.data.totalCnt, payload),
      };

      yield put({ type: orderActions.GET_ORDER_CANCEL_MANAGEMENT_LIST_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(orderToastMsg.GET_ORDER_CANCEL_MANAGEMENT_LIST_REQUEST_ERROR, e);
    }
  });

  /**
   *  [취소 관리] 취소 관리 전체 리스트 엑셀 다운로드 요청하기
   */
  yield takeEvery(orderActions.GET_ORDER_CANCEL_MANAGEMENT_ALL_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.getOrderCancelManagementAllListExcelDownload, setRequestForm(payload, true));
      noticeExcelDownloadResult(payload.email, result.msg);
    } catch (e) {
      toastMsg.error(e.message || orderToastMsg.GET_ORDER_CANCEL_MANAGEMENT_ALL_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR);
    }
  });

  /**
   *  [취소 관리] 취소 관리 선택 리스트 엑셀 다운로드 요청하기
   */
  yield takeEvery(
    orderActions.GET_ORDER_CANCEL_MANAGEMENT_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST,
    function* ({ payload }) {
      try {
        const result = yield call(
          OrderApi.getOrderCancelManagementSelectedListExcelDownload,
          setRequestForm(payload, true),
        );
        if (result.msg) {
          toastMsg.error(result.msg);
          return;
        }

        toastMsg.success(orderToastMsg.GET_ORDER_CANCEL_MANAGEMENT_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

        excelDownLoad(payload.fileName, result.data.orderCancelManagementListExcelSheet);
      } catch (e) {
        toastMsg.error(
          e.message || orderToastMsg.GET_ORDER_CANCEL_MANAGEMENT_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR,
        );
      }
    },
  );

  /**
   *  [취소 관리] 취소 거부 요청하기
   */
  yield takeEvery(orderActions.REJECT_ORDER_CANCEL_ITEM_DATA_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.rejectOrderCancel, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.REJECT_ORDER_CANCEL_ITEM_DATA_REQUEST_SUCCESS);

      const data = {
        orderItemIdList: result.data.orderItemIdList,
        rejectDate: result.data.rejectDate,
        rejectReason: result.data.rejectReason,
      };

      yield put({ type: orderActions.REJECT_ORDER_CANCEL_ITEM_DATA_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(orderToastMsg.REJECT_ORDER_CANCEL_ITEM_DATA_REQUEST_ERROR, e);
    }
  });

  /**
   *  [취소 관리] 취소 완료 요청 전 상품 또는 옵션의 재고, 상태 설정 리스트 요청하기
   */
  yield takeEvery(orderActions.GET_ORDER_CANCEL_ITEM_STOCK_AND_STATUS_DATA_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.getOrderCancelStockAndStatusList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.GET_ORDER_CANCEL_ITEM_STOCK_AND_STATUS_DATA_LIST_REQUEST_SUCCESS);

      yield put(
        orderActions.toggleModal({
          name: 'cancelCompleteConfirmModal',
          data: {
            orderItemList: result.data.orderItemList,
          },
        }),
      );
    } catch (e) {
      toastMsg.error(orderToastMsg.GET_ORDER_CANCEL_ITEM_STOCK_AND_STATUS_DATA_LIST_REQUEST_SUCCESS, e);
    }
  });

  /**
   *  [취소 관리] 취소 완료 요청하기
   */
  yield takeEvery(orderActions.COMPLETE_ORDER_CANCEL_ITEM_DATA_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.completeOrderCancel, setRequestForm(payload, true));
      if (result.status === ORDER_RES_CODE.CAN_NOT_CANCEL_PART_ORDER_ITEM) {
        toastMsg.error(orderToastMsg.CAN_NOT_CANCEL_PART_ORDER_ITEM);
        return;
      }

      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.COMPLETE_ORDER_CANCEL_ITEM_DATA_REQUEST_SUCCESS);

      const data = {
        orderItemIdList: result.data.orderItemIdList,
        cancelCompleteDataList: result.data.cancelCompleteDataList,
      };

      yield put({ type: orderActions.COMPLETE_ORDER_CANCEL_ITEM_DATA_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(orderToastMsg.COMPLETE_ORDER_CANCEL_ITEM_DATA_REQUEST_ERROR, e);
    }
  });

  /**
   * 택배사 리스트 가져오기
   */
  yield takeEvery(orderActions.GET_DELIVERY_AGENT_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(AppApi.getDeliveryAgentList, setRequestForm({}, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      /**
       *  발송 처리를 위해 배송 택배 정보를
       *  입력하는 모달을 열도록 함
       */
      const data = {
        deliveryAgentList: addAllItemToSelectList(result.data.deliveryAgentList, '택배사 선택'),
        ...payload,
      };

      yield put(
        orderActions.toggleModal({
          name: ['rejectCancelDeliveryDispatchModal'],
          data,
        }),
      );
    } catch (e) {
      toastMsg.error(orderToastMsg.GET_DELIVERY_AGENT_LIST_REQUEST_ERROR, e);
    }
  });

  /**
   *  [취소 관리] 취소 거부 -> 발송 처리하기
   */
  yield takeEvery(orderActions.DELIVERY_DISPATCH_ORDER_CANCEL_ITEM_DATA_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.rejectOrderCancelDeliveryDispatch, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.DELIVERY_DISPATCH_ORDER_CANCEL_ITEM_DATA_REQUEST_SUCCESS);

      const data = {
        orderItemId: result.data.orderItemId,
      };

      yield put({ type: orderActions.DELIVERY_DISPATCH_ORDER_CANCEL_ITEM_DATA_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(orderToastMsg.DELIVERY_DISPATCH_ORDER_CANCEL_ITEM_DATA_REQUEST_ERROR, e);
    }
  });

  /**
   *  [반품 관리] 반품 관리 리스트 요청하기
   */
  yield takeEvery(orderActions.GET_ORDER_RETURN_MANAGEMENT_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.getOrderReturnManagementList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.GET_ORDER_RETURN_MANAGEMENT_LIST_REQUEST_SUCCESS);

      const data = {
        orderReturnManagementList: _setResponseListForm(result.data.orderItemList, result.data.totalCnt, payload),
      };

      yield put({ type: orderActions.GET_ORDER_RETURN_MANAGEMENT_LIST_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(orderToastMsg.GET_ORDER_RETURN_MANAGEMENT_LIST_REQUEST_ERROR, e);
    }
  });

  /**
   *  [반품 관리] 전체 리스트 엑셀 다운로드 요청하기
   */
  yield takeEvery(orderActions.GET_ORDER_RETURN_MANAGEMENT_ALL_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.getOrderReturnManagementAllListExcelDownload, setRequestForm(payload, true));
      noticeExcelDownloadResult(payload.email, result.msg);
    } catch (e) {
      toastMsg.error(e.message || orderToastMsg.GET_ORDER_RETURN_MANAGEMENT_ALL_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR);
    }
  });

  /**
   *  [반품 관리] 선택 리스트 엑셀 다운로드 요청하기
   */
  yield takeEvery(
    orderActions.GET_ORDER_RETURN_MANAGEMENT_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST,
    function* ({ payload }) {
      try {
        const result = yield call(
          OrderApi.getOrderReturnManagementSelectedListExcelDownload,
          setRequestForm(payload, true),
        );
        if (result.msg) {
          toastMsg.error(result.msg);
          return;
        }

        toastMsg.success(orderToastMsg.GET_ORDER_RETURN_MANAGEMENT_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

        excelDownLoad(payload.fileName, result.data.orderReturnManagementListExcelSheet);
      } catch (e) {
        toastMsg.error(
          e.message || orderToastMsg.GET_ORDER_RETURN_MANAGEMENT_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR,
        );
      }
    },
  );

  /**
   *  [반품 관리] 반품 수거 완료 요청하기
   */
  yield takeEvery(orderActions.COMPLETE_COLLECTION_ORDER_RETURN_ITEM_DATA_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.completeCollectionOrderReturn, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.COMPLETE_COLLECTION_ORDER_RETURN_ITEM_DATA_REQUEST_SUCCESS);

      const data = {
        orderItemIdList: result.data.orderItemIdList,
        receiveDate: result.data.receiveDate,
      };

      yield put({ type: orderActions.COMPLETE_COLLECTION_ORDER_RETURN_ITEM_DATA_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(orderToastMsg.COMPLETE_COLLECTION_ORDER_RETURN_ITEM_DATA_REQUEST_ERROR, e);
    }
  });

  /**
   *  [반품 관리] 반품 거부 요청하기
   */
  yield takeEvery(orderActions.REJECT_ORDER_RETURN_ITEM_DATA_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.rejectOrderReturn, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.REJECT_ORDER_RETURN_ITEM_DATA_REQUEST_SUCCESS);

      const data = {
        orderItemId: result.data.orderItemId,
        rejectDate: result.data.rejectDate,
        returnRejectReason: payload.reason,
      };

      yield put({ type: orderActions.REJECT_ORDER_RETURN_ITEM_DATA_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(orderToastMsg.REJECT_ORDER_RETURN_ITEM_DATA_REQUEST_ERROR, e);
    }
  });

  /**
   *  [반품 관리] 반품 사유 수정하기 전 필요한 데이터 요청하기
   */
  yield takeEvery(orderActions.GET_PREPARATION_EDIT_REASON_ORDER_RETURN_ITEM_DATA_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.getPreparationOrderReturnModifyReason, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.GET_PREPARATION_MODIFY_REASON_ORDER_RETURN_ITEM_DATA_REQUEST_SUCCESS);

      yield put(
        orderActions.toggleModal({
          name: 'editReasonReturnModal',
          data: {
            orderItemInfo: result.data.orderItemInfo,
            returnAttachments: result.data.returnAttachments,
          },
        }),
      );
    } catch (e) {
      toastMsg.error(orderToastMsg.GET_PREPARATION_MODIFY_REASON_ORDER_RETURN_ITEM_DATA_REQUEST_ERROR, e);
    }
  });

  /**
   *  [반품 관리] 반품 사유 수정 요청하기
   */
  yield takeEvery(orderActions.EDIT_ORDER_RETURN_ITEM_REASON_DATA_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.editOrderReturnReason, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.EDIT_ORDER_RETURN_ITEM_REASON_DATA_REQUEST_SUCCESS);

      const data = {
        orderItemList: result.data.orderItemList,
        returnReasonModifyDate: result.data.returnReasonModifyDate,
        returnType: payload.reasonType,
        returnReason: payload.reason,
      };

      yield put({ type: orderActions.EDIT_ORDER_RETURN_ITEM_REASON_DATA_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(orderToastMsg.EDIT_ORDER_RETURN_ITEM_REASON_DATA_REQUEST_ERROR, e);
    }
  });

  /**
   *  [반품 관리] 반품 승인 요청하기
   */
  yield takeEvery(orderActions.COMPLETE_ORDER_RETURN_ITEM_DATA_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.completeOrderReturn, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.COMPLETE_ORDER_RETURN_ITEM_DATA_REQUEST_SUCCESS);

      const data = {
        orderItemId: result.data.orderItemId,
        refundSellerAmount: payload.refundSellerAmount,
        returnCompleteDate: result.data.returnCompleteDate,
      };

      yield put({ type: orderActions.COMPLETE_ORDER_RETURN_ITEM_DATA_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(orderToastMsg.COMPLETE_ORDER_RETURN_ITEM_DATA_REQUEST_ERROR, e);
    }
  });

  /**
   *  [반품 관리] 반품 -> 교환 요청하기
   */
  yield takeEvery(orderActions.CHANGE_EXCHANGE_ORDER_RETURN_ITEM_DATA_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.changeReturnToExchange, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.CHANGE_EXCHANGE_ORDER_RETURN_ITEM_DATA_REQUEST_SUCCESS);

      const data = {
        orderItemId: payload.orderItemId,
      };

      yield put({ type: orderActions.CHANGE_EXCHANGE_ORDER_RETURN_ITEM_DATA_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(orderToastMsg.CHANGE_EXCHANGE_ORDER_RETURN_ITEM_DATA_REQUEST_ERROR, e);
    }
  });

  /**
   *  [반품 관리] 반품 사유, 반품 거부 사유 이미지 요청하기
   */
  yield takeEvery(orderActions.GET_ORDER_RETURN_ITEM_ATTACHMENT_DATA_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.getOrderReturnAttachment, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.GET_ORDER_RETURN_ITEM_ATTACHMENT_DATA_REQUEST_SUCCESS);

      const data = {
        attachments: result.data.targetAttachments,
        ...payload,
      };

      /**
       *  반품 요청, 반품 거부 사유 모달 열기
       */
      yield put(
        orderActions.toggleModal({
          name: 'returnReasonModal',
          data,
        }),
      );
    } catch (e) {
      toastMsg.error(orderToastMsg.GET_ORDER_RETURN_ITEM_ATTACHMENT_DATA_REQUEST_ERROR, e);
    }
  });

  /**
   *  [교환 관리] 교환 관리 리스트 요청하기
   */
  yield takeEvery(orderActions.GET_ORDER_EXCHANGE_MANAGEMENT_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.getOrderExchangeManagementList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.GET_ORDER_EXCHANGE_MANAGEMENT_LIST_REQUEST_SUCCESS);

      const data = {
        orderExchangeManagementList: _setResponseListForm(result.data.orderItemList, result.data.totalCnt, payload),
      };

      yield put({ type: orderActions.GET_ORDER_EXCHANGE_MANAGEMENT_LIST_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(orderToastMsg.GET_ORDER_EXCHANGE_MANAGEMENT_LIST_REQUEST_ERROR, e);
    }
  });

  /**
   *  [교환 관리] 전체 리스트 엑셀 다운로드 요청하기
   */
  yield takeEvery(orderActions.GET_ORDER_EXCHANGE_MANAGEMENT_ALL_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.getOrderExchangeManagementAllListExcelDownload, setRequestForm(payload, true));
      noticeExcelDownloadResult(payload.email, result.msg);
    } catch (e) {
      toastMsg.error(e.message || orderToastMsg.GET_ORDER_EXCHANGE_MANAGEMENT_ALL_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR);
    }
  });

  /**
   *  [교환 관리] 선택 리스트 엑셀 다운로드 요청하기
   */
  yield takeEvery(
    orderActions.GET_ORDER_EXCHANGE_MANAGEMENT_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST,
    function* ({ payload }) {
      try {
        const result = yield call(
          OrderApi.getOrderExchangeManagementSelectedListExcelDownload,
          setRequestForm(payload, true),
        );
        if (result.msg) {
          toastMsg.error(result.msg);
          return;
        }

        toastMsg.success(orderToastMsg.GET_ORDER_EXCHANGE_MANAGEMENT_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

        excelDownLoad(payload.fileName, result.data.orderExchangeManagementListExcelSheet);
      } catch (e) {
        toastMsg.error(
          e.message || orderToastMsg.GET_ORDER_EXCHANGE_MANAGEMENT_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR,
        );
      }
    },
  );

  /**
   *  [교환 관리] 교환 수거 완료 요청하기
   */
  yield takeEvery(orderActions.COMPLETE_COLLECTION_ORDER_EXCHANGE_ITEM_DATA_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.completeCollectionOrderExchange, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.COMPLETE_COLLECTION_ORDER_EXCHANGE_ITEM_DATA_REQUEST_SUCCESS);

      const data = {
        orderItemIdList: result.data.orderItemIdList,
        receiveDate: result.data.receiveDate,
      };

      yield put({ type: orderActions.COMPLETE_COLLECTION_ORDER_EXCHANGE_ITEM_DATA_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(orderToastMsg.COMPLETE_COLLECTION_ORDER_EXCHANGE_ITEM_DATA_REQUEST_ERROR, e);
    }
  });

  /**
   *  [교환 관리] 교환 거부 요청하기
   */
  yield takeEvery(orderActions.REJECT_ORDER_EXCHANGE_ITEM_DATA_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.rejectOrderExchange, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.REJECT_ORDER_EXCHANGE_ITEM_DATA_REQUEST_SUCCESS);

      const data = {
        orderItemId: result.data.orderItemId,
        rejectDate: result.data.rejectDate,
        rejectReason: payload.reason,
      };

      yield put({ type: orderActions.REJECT_ORDER_EXCHANGE_ITEM_DATA_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(orderToastMsg.REJECT_ORDER_EXCHANGE_ITEM_DATA_REQUEST_ERROR, e);
    }
  });

  /**
   *  [교환 관리] 교환 사유 수정하기 전 필요한 데이터 요청하기
   */
  yield takeEvery(orderActions.GET_PREPARATION_EDIT_REASON_ORDER_EXCHANGE_ITEM_DATA_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.getPreparationOrderExchangeEditReason, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.GET_PREPARATION_EDIT_REASON_ORDER_EXCHANGE_ITEM_DATA_REQUEST_SUCCESS);

      /**
       *  교환 사유 수정을 위해 교환 사유와 교환 상세 사유를
       *  입력하는 모달을 열도록 함
       */
      yield put(
        orderActions.toggleModal({
          name: 'editExchangeReasonModal',
          data: {
            orderItemInfo: result.data.orderItemInfo,
            exchangeAttachments: result.data.exchangeAttachments,
          },
        }),
      );
    } catch (e) {
      toastMsg.error(orderToastMsg.GET_PREPARATION_EDIT_REASON_ORDER_EXCHANGE_ITEM_DATA_REQUEST_ERROR, e);
    }
  });

  /**
   *  [교환 관리] 교환 사유 수정 요청하기
   */
  yield takeEvery(orderActions.EDIT_ORDER_EXCHANGE_ITEM_REASON_DATA_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.editOrderExchangeReason, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.EDIT_ORDER_EXCHANGE_ITEM_REASON_DATA_REQUEST_SUCCESS);

      const data = {
        orderItemIdList: result.data.orderItemIdList,
        exchangeReasonModifyDate: result.data.exchangeReasonModifyDate,
        exchangeType: payload.reasonType,
        exchangeReason: payload.reason,
      };

      yield put({ type: orderActions.EDIT_ORDER_EXCHANGE_ITEM_REASON_DATA_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(orderToastMsg.EDIT_ORDER_EXCHANGE_ITEM_REASON_DATA_REQUEST_ERROR, e);
    }
  });

  /**
   *  [교환 관리] 택배사 리스트 가져오기
   */
  yield takeEvery(orderActions.GET_DELIVERY_AGENT_LIST_FOR_ORDER_EXCHANGE_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(AppApi.getDeliveryAgentList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      /**
       *  교환 재배송 처리를 위해 교환 배송 택배 정보를
       *  입력하는 모달을 열도록 함
       */
      const data = {
        deliveryAgentList: addAllItemToSelectList(result.data.deliveryAgentList, '택배사 선택'),
        ...omit(payload, ['targetModalName']),
      };

      yield put(
        orderActions.toggleModal({
          name: payload.targetModalName,
          data,
        }),
      );
    } catch (e) {
      toastMsg.error(orderToastMsg.GET_DELIVERY_AGENT_LIST_FOR_ORDER_EXCHANGE_REQUEST_ERROR, e);
    }
  });

  /**
   *  [교환 관리] 교환 재배송 송장 수정 요청하기
   */
  yield takeEvery(orderActions.EDIT_ORDER_EXCHANGE_ITEM_DELIVERY_INFO_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.editOrderExchangeDeliveryInfo, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.EDIT_ORDER_EXCHANGE_ITEM_DELIVERY_INFO_REQUEST_SUCCESS);

      const data = {
        orderItemList: result.data.responseOrderItemList,
        exchangeDeliveryType: payload.deliveryType,
        exchangeInvoiceNumber: payload.invoiceNumber,
      };

      yield put({ type: orderActions.EDIT_ORDER_EXCHANGE_ITEM_DELIVERY_INFO_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(orderToastMsg.EDIT_ORDER_EXCHANGE_ITEM_DELIVERY_INFO_REQUEST_ERROR, e);
    }
  });

  /**
   *  [교환 관리] 교환 승인 요청하기
   */
  yield takeEvery(orderActions.COMPLETE_ORDER_EXCHANGE_ITEM_DATA_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.completeOrderExchange, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.COMPLETE_ORDER_EXCHANGE_ITEM_DATA_REQUEST_SUCCESS);

      const data = {
        orderItemId: result.data.orderItemId,
        orderItemExchangeStatus: result.data.orderItemExchangeStatus,
        exchangeDispatchDate: result.data.exchangeDispatchDate,
        exchangeCompleteDate: result.data.exchangeCompleteDate,
        exchangeDeliveryId: result.data.exchangeDeliveryId,
        exchangeDeliveryType: payload.deliveryType,
        exchangeDeliveryAgentName: result.data.exchangeDeliveryAgentName,
        exchangeInvoiceNumber: payload.invoiceNumber,
        exchangeBuyerPhone: payload.buyerPhone,
        exchangeRecipientPhone: payload.recipientPhone,
        exchangeShippingAddress: `${payload.address.line1} ${payload.address.line2}`,
        exchangeShippingPostCode: payload.address.postCode,
        exchangeShippingMessage: payload.message,
      };

      yield put({ type: orderActions.COMPLETE_ORDER_EXCHANGE_ITEM_DATA_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(orderToastMsg.COMPLETE_ORDER_EXCHANGE_ITEM_DATA_REQUEST_ERROR, e);
    }
  });

  /**
   *  [교환 관리] 교환 -> 반품 요청하기
   */
  yield takeEvery(orderActions.CHANGE_RETURN_ORDER_EXCHANGE_ITEM_DATA_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.changeExchangeToReturn, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.CHANGE_RETURN_ORDER_EXCHANGE_ITEM_DATA_REQUEST_SUCCESS);

      const data = {
        orderItemId: payload.orderItemId,
      };

      yield put({ type: orderActions.CHANGE_RETURN_ORDER_EXCHANGE_ITEM_DATA_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(orderToastMsg.CHANGE_RETURN_ORDER_EXCHANGE_ITEM_DATA_REQUEST_ERROR, e);
    }
  });

  /**
   *  [교환 관리] 교환 사유, 교환 거부 사유 이미지 요청하기
   */
  yield takeEvery(orderActions.GET_ORDER_EXCHANGE_ITEM_ATTACHMENT_DATA_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.getOrderExchangeAttachment, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.GET_ORDER_EXCHANGE_ITEM_ATTACHMENT_DATA_REQUEST_SUCCESS);

      const data = {
        attachments: result.data.targetAttachments,
        ...payload,
      };

      /**
       *  교환 요청, 교환 거부 사유 모달 열기
       */
      yield put(
        orderActions.toggleModal({
          name: 'exchangeReasonModal',
          data,
        }),
      );

      yield put({ type: orderActions.GET_ORDER_EXCHANGE_ITEM_ATTACHMENT_DATA_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(orderToastMsg.GET_ORDER_EXCHANGE_ITEM_ATTACHMENT_DATA_REQUEST_ERROR, e);
    }
  });

  /**
   *  [주문 상세] 주문 상세 요청하기
   */
  yield takeEvery(orderActions.GET_ORDER_DETAIL_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.getOrderDetail, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(orderToastMsg.GET_ORDER_DETAIL_REQUEST_SUCCESS);

        const data = {
          orderDetail: {
            ...result.data.orderDetail,
            inquiryInfo: setResponseListForm(
              result.data.orderDetail.inquiryList.list,
              result.data.orderDetail.inquiryList.totalCnt,
              payload.inquiryHistory,
            ),
            qnaInfo: setResponseListForm(
              result.data.orderDetail.qnaList.list,
              result.data.orderDetail.qnaList.totalCnt,
              payload.qnaHistory,
            ),
          },
        };

        yield put({ type: orderActions.GET_ORDER_DETAIL_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(orderToastMsg.GET_ORDER_DETAIL_REQUEST_ERROR, error);
    }
  });

  /**
   *  [주문 상세] 주문 상태 되돌리기 요청하기
   */
  yield takeEvery(orderActions.CHANGE_ORDER_ITEM_STATUS_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.changeOrderItemStatus, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(orderToastMsg.CHANGE_ORDER_ITEM_STATUS_REQUEST_SUCCESS);

        const data = {
          orderItemId: payload.orderItemId,
          ...initOrderDetailListOption,
        };
        yield put({ type: orderActions.GET_ORDER_DETAIL_REQUEST, payload: data });
      }
    } catch (error) {
      toastMsg.error(orderToastMsg.CHANGE_ORDER_ITEM_STATUS_REQUEST_ERROR, error);
      /**
       *  상태 변경에 실패했을 경우 페이지를 새로고침한다.
       */
      window.location.reload();
    }
  });

  /**
   *  [주문 상세] 주문 상태 되돌리기 요청하기 (구매 확정)
   */
  yield takeEvery(orderActions.CHANGE_ORDER_CONFIRMS_STATUS_REQUEST, function* ({ payload }) {
    try {
      yield call(OrderApi.changeOrderConfirms, payload);
      toastMsg.success(orderToastMsg.CHANGE_ORDER_ITEM_STATUS_REQUEST_SUCCESS);
      const data = {
        orderItemId: payload.orderItemId,
        ...initOrderDetailListOption,
      };
      yield put({ type: orderActions.GET_ORDER_DETAIL_REQUEST, payload: data });
    } catch (error) {
      const { errors } = error.response.data;
      const errMsg = errors.reduce((a, c) => {
        return (a += c.message + '\n');
      }, '');
      yield asyncSimpleModal({
        type: 'error',
        title: '주문 상태 되돌리기 불가',
        message: errMsg,
      });
    }
  });

  /**
   *  [주문 반품 상세] 주문 반품 상세 요청하기
   */
  yield takeEvery(orderActions.GET_ORDER_RETURN_DETAIL_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.getOrderReturnDetail, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(orderToastMsg.GET_ORDER_RETURN_DETAIL_REQUEST_SUCCESS);

        const data = {
          orderReturnDetail: result.data.orderReturnDetail,
        };
        yield put({ type: orderActions.GET_ORDER_RETURN_DETAIL_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(orderToastMsg.GET_ORDER_RETURN_DETAIL_REQUEST_ERROR);
    }
  });

  /**
   * [주문 반품 상세] 주문 반품 환불 완료하기
   */
  yield takeEvery(orderActions.SET_COMPLETE_REFUND_ORDER_RETURN_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.setCompleteRefundOrderReturn, setRequestForm(payload, true));
      if (result.status === ORDER_RES_CODE.CAN_NOT_CANCEL_PART_ORDER_ITEM) {
        toastMsg.error(orderToastMsg.CAN_NOT_CANCEL_PART_ORDER_ITEM);
        return;
      }

      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.SET_COMPLETE_REFUND_ORDER_RETURN_REQUEST_SUCCESS);
      reDirectPage({ path: ORDER_RETURN_LIST_URL_PATH });
    } catch (error) {
      toastMsg.error(orderToastMsg.SET_COMPLETE_REFUND_ORDER_RETURN_REQUEST_ERROR);
    }
  });

  /**
   *  [주문상세] 교환 요청하기
   */
  yield takeEvery(orderActions.SUBMIT_ORDER_EXCHANGE_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.orderExchangeRequest, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.SUBMIT_ORDER_EXCHANGE_REQUEST_SUCCESS);

      const data = {
        /**
         *  주문 상세 정보
         */
        orderDetail: {
          /**
           * 주문 정보 탭
           */
          orderInfo: result.data.orderDetail.orderInfo,
          /**
           *  교환 이력 탭
           */
          exchangeHistory: result.data.orderDetail.exchangeHistory,
        },
      };

      yield put({ type: orderActions.SUBMIT_ORDER_EXCHANGE_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(orderToastMsg.SUBMIT_ORDER_EXCHANGE_REQUEST_ERROR, e);
    }
  });

  /**
   *  [주문상세] 반품요청에 필요한 데이터 요청하기
   */
  yield takeEvery(orderActions.GET_PREPARATION_ORDER_RETURN_REQUEST, function* ({ payload }) {
    try {
      const { orderId, data } = payload;
      const result = yield call(OrderApi.getPreparationOrderReturnRequest, setRequestForm({ orderId }, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.GET_PREPARATION_ORDER_RETURN_REQUEST_SUCCESS);

      yield put(
        orderActions.toggleModal({
          name: 'orderItemReturnExchangeRequestModal',
          data: {
            ...data,
            bankId: result.data.bankId,
            bankNumber: result.data.bankNumber,
            bankHolder: result.data.bankHolder,
            bankList: result.data.bankList,
          },
        }),
      );
    } catch (e) {
      toastMsg.error(orderToastMsg.GET_PREPARATION_ORDER_RETURN_REQUEST_ERROR, e);
    }
  });

  /**
   *  [주문상세] 반품 요청하기
   */
  yield takeEvery(orderActions.SUBMIT_ORDER_RETURN_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.orderReturnRequest, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.SUBMIT_ORDER_RETURN_REQUEST_SUCCESS);

      const data = {
        /**
         *  주문 상세 정보
         */
        orderDetail: {
          /**
           * 주문 정보 탭
           */
          orderInfo: result.data.orderDetail.orderInfo,
          /**
           *  반품 이력 탭
           */
          returnHistory: result.data.orderDetail.returnHistory,
        },
      };

      yield put({ type: orderActions.SUBMIT_ORDER_RETURN_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(orderToastMsg.SUBMIT_ORDER_RETURN_REQUEST_ERROR, e);
    }
  });

  /**
   *  [주문상세] cs 메모 등록 요청하기
   */
  yield takeEvery(orderActions.INSERT_ORDER_ITEM_CS_MEMO_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.insertOrderItemCsMemoRequest, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.INSERT_ORDER_ITEM_CS_MEMO_REQUEST_SUCCESS);

      const data = {
        orderItemCsList: result.data.orderItemCsList,
      };

      yield put({ type: orderActions.INSERT_ORDER_ITEM_CS_MEMO_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(orderToastMsg.INSERT_ORDER_ITEM_CS_MEMO_REQUEST_ERROR, e);
    }
  });

  /**
   *  [주문상세] cs 메모 업데이트 요청하기
   */
  yield takeEvery(orderActions.EDIT_ORDER_ITEM_CS_MEMO_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.editOrderItemCsMemoRequest, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.EDIT_ORDER_ITEM_CS_MEMO_REQUEST_SUCCESS);

      const data = {
        orderItemCsList: result.data.orderItemCsList,
      };

      yield put({ type: orderActions.EDIT_ORDER_ITEM_CS_MEMO_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(orderToastMsg.EDIT_ORDER_ITEM_CS_MEMO_REQUEST_ERROR, e);
    }
  });

  /**
   *  [주문상세] 1:1 문의 리스트 요청하기
   */
  yield takeEvery(orderActions.GET_ORDER_ITEM_CS_INQUIRY_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.getOrderItemCsInquiryList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.GET_ORDER_ITEM_CS_INQUIRY_LIST_REQUEST_SUCCESS);

      const data = {
        inquiryInfo: setResponseListForm(result.data.inquiryList.list, result.data.inquiryList.totalCnt, payload),
      };

      yield put({ type: orderActions.GET_ORDER_ITEM_CS_INQUIRY_LIST_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(orderToastMsg.GET_ORDER_ITEM_CS_INQUIRY_LIST_REQUEST_ERROR, e);
    }
  });

  /**
   *  [주문상세] 1:1 문의 리스트 엑셀 다운로드 요청하기
   */
  yield takeEvery(orderActions.GET_ORDER_ITEM_CS_INQUIRY_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.getOrderItemCsInquiryListExcelDownload, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.GET_ORDER_ITEM_CS_INQUIRY_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

      excelDownLoad('주문 상세 문의 리스트', result.data.orderItemInquiryExcelSheet);
    } catch (e) {
      toastMsg.error(e.message);
    }
  });

  /**
   *  [주문상세] 상품 문의 리스트 요청하기
   */
  yield takeEvery(orderActions.GET_ORDER_ITEM_CS_QNA_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.getOrderItemCsQnaList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.GET_ORDER_ITEM_CS_QNA_LIST_REQUEST_SUCCESS);

      const data = {
        qnaInfo: setResponseListForm(result.data.qnaList.list, result.data.qnaList.totalCnt, payload),
      };

      yield put({ type: orderActions.GET_ORDER_ITEM_CS_QNA_LIST_SUCCESS, payload: data });
    } catch (e) {
      toastMsg.error(orderToastMsg.GET_ORDER_ITEM_CS_QNA_LIST_REQUEST_ERROR, e);
    }
  });

  /**
   *  [주문상세] 상품 문의 리스트 엑셀 다운로드 요청하기
   */
  yield takeEvery(orderActions.GET_ORDER_ITEM_CS_QNA_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(OrderApi.getOrderItemCsQnaListExcelDownload, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(orderToastMsg.GET_ORDER_ITEM_CS_QNA_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

      excelDownLoad('주문 상세 상품 문의 리스트', result.data.orderItemQnaExcelSheet);
    } catch (e) {
      toastMsg.error(e.message || orderToastMsg.GET_ORDER_ITEM_CS_QNA_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR);
    }
  });
}

export default function* widgetSaga() {
  yield fork(fetchList);
}
